<template>
  <div class="module-wrap">
    <div class="w1920">
      <div class="w1200">
        <div class="slogan">
          <h2>AI智能体市场</h2>
          <p>
            Rainstore
            通过云原生技术，帮助ToB软件企业转型商业模式和升级交付能力，驱动企业业务增长。
          </p>
          <div class="btn-wrap">
            <el-button
              v-if="!disableButton"
              type="primary"
              @click="
                () => {
                  this.$router.push({
                    name: 'marketregist'
                  });
                }
              "
              >申请试用</el-button
            >
          </div>
        </div>

        <div class="join-step-wrap">
          <ul>
            <li class="first">
              <span>
                <i>1</i>
                {{ step === 'marketregist' ? '申请试用' : '了解Rainstore' }}
              </span>
            </li>
            <li>
              <span>
                <i>2</i>
                {{ step === 'marketregist' ? '审核通过' : '填写申请信息' }}
              </span>
            </li>
            <li>
              <span>
                <i>3</i>
                开通店铺
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['disableButton'],
  computed: {
    step() {
      return this.$route.name;
    }
  }
};
</script>
<style lang="scss" scoped>
.module-wrap {
  margin-top: 60px;
  background: -webkit-gradient(
    linear,
    0 0,
    0 bottom,
    from(#242627),
    to(#242627)
  );
  position: relative;
  height: 440px;
  .w1920 {
    width: 100%;
    height: 100%;
    background: url('../../../assets/images/background.jpg') no-repeat center
      bottom;
    background-size: 1920px auto;
  }
  .w1200 {
    position: relative;
    width: 1200px;
    height: 100%;
    margin: 0 auto;
  }
  .slogan {
    padding-top: 155px;
    text-align: center;
    h2 {
      margin-bottom: 10px;
      color: #fff;
      font-size: 36px;
    }
    p {
      margin-bottom: 30px;
      padding: 0 200px;
      font-size: 16px;
      color: #fff;
      line-height: 1.6;
    }
  }
  .join-step-wrap {
    position: absolute;
    left: 10px;
    bottom: -40px;
    z-index: 10;
    width: 1180px;
    height: 80px;
    box-sizing: border-box;
    padding: 40px 40px 0;
    background: #409eff;
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);
    ul {
      float: left;
      margin-left: 227px;
      border-top: 2px solid #ffffff;
      &:before {
        content: '';
        display: table;
      }
      li {
        position: relative;
        top: -20px;
        float: left;
        margin-left: 130px;
        line-height: 40px;
        font-weight: 700;
        font-size: 16px;
        color: #fff;
        i {
          display: inline-block;
          width: 16px;
          height: 16px;
          color: #fff;
          font-size: 13px;
          line-height: 17px;
          font-weight: 400;
          text-align: center;
          border: 1px solid #fff;
          border-radius: 100%;
          font-style: normal;
        }
        span {
          padding: 15px;
          background: #409eff;
        }
      }
      li.first {
        margin-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/indexheader.vue